import { useState, useEffect } from 'react'
import styles from './CardCollection.module.scss'

function CardCollection(props) {
   const [imageSrc, setImageSrc] = useState(null)

   useEffect(() => {
      if (!props.image) return

      let cancelled = false
      let objectUrl = null

      fetch(props.image, { cache: 'no-store' })
         .then((res) => res.blob())
         .then((blob) => {
            if (!cancelled) {
               objectUrl = URL.createObjectURL(blob)
               setImageSrc(objectUrl)
            }
         })

      return () => {
         cancelled = true
         if (objectUrl) URL.revokeObjectURL(objectUrl)
      }
   }, [props.image])

   function onClick(evt) {
      if (props.onClick) {
         props.onClick(evt)
      }
   }

   return (
      <button className={styles.card_collection} onClick={onClick}>
         {imageSrc && <img src={imageSrc} alt="Model" />}
         <div>
            <label>{props.label}</label>
         </div>
      </button>
   )
}

export default CardCollection
